import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Indicates that tokenization was not possible for a card or APM payment, or for a vaulted token.`}</p>
    <p>{`For new tokens, this frequently occurs due to issues validating the provided data from which the token is created.`}</p>
    <p>{`For vaulted tokens this can occur if a payment method token cannot be created from the vaulted token.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      